import React from "react";
import { Props } from "./types";
import { List } from "./list";
import { Task } from "./task";
import { Event } from "./event";
import { Milestone } from "./milestone";

const HEIGHT_RATIO = 8 / 10;
const cell = {
  height: 30,
  width: 30,
};

function Element({ element }: Props) {
  const CurrentElement =
    element.isList || element.isProject
      ? List
      : element.isTask
        ? Task
        : element.isMilestone
          ? Milestone
          : element.isEvent
            ? Event
            : () => <React.Fragment />;

  return (
    <div style={{ height: cell.height, width: cell.width * 3 }}>
      <CurrentElement
        element={element}
        progress={
          element.isTask
            ? "percentComplete" in element && element.percentComplete === 100
              ? 100
              : element.isMilestone &&
                  "state" in element &&
                  element.state === "DONE"
                ? 100
                : 0
            : 0
        }
        height={element.isMilestone ? cell.height : cell.height * HEIGHT_RATIO}
        width={cell.width * 3}
      />
    </div>
  );
}

export { Element };
